import { createContext, useContext, useEffect, useState } from "react";
import { useSelector, DefaultRootState } from "react-redux";
import Chat from "../../components/Widgets/DefaultWidgets/Chat";
import {
   ChatMessageInterface,
   ChatRoomInterface
} from "../../components/Widgets/WidgetsSettings/ChatSettings/ChatInterfaces";
//Here we can easly provide all data to non relate components, by adding here property, and setting it by setMailContext
//To use this context you simply type useMails and get state or function that you need
export type ChatContextData = {
   chatData: {
      publicRooms: any[];
      privateRooms: any[];
      filteredPrivateRooms: any[];
      directRooms: any[];
      users: any[];
      phpUsers: any[];
      filteredPhpUsers: any[];
      allRooms: any[];
      messages: ChatMessageInterface[];
   };
   setChatData: (chatData: any) => void;
};

const ChatContext = createContext<ChatContextData>({
   chatData: {
      publicRooms: [],
      privateRooms: [],
      filteredPrivateRooms: [],
      directRooms: [],
      users: [],
      phpUsers: [],
      filteredPhpUsers: [],
      allRooms: [],
      messages: []
   },
   setChatData: () => {}
});

const ChatProvider = ({ children }) => {
   const [chatData, setChatData] = useState({
      publicRooms: [],
      privateRooms: [],
      filteredPrivateRooms: [],
      directRooms: [],
      users: [],
      phpUsers: [],
      filteredPhpUsers: [],
      allRooms: [],
      messages: []
   });

   const { authUser } = useSelector(({ auth }) => auth);

   const isLocationProper = () => {
      let locationIsProper = true;
      const href = window.location.href;
      if (href?.includes("signin") || href?.includes("signup")) {
         locationIsProper = false;
      }
      return locationIsProper;
   };

   return (
      <ChatContext.Provider
         value={{
            chatData,
            setChatData
         }}
      >
         {children}
         {authUser && isLocationProper() ? <Chat /> : null}
      </ChatContext.Provider>
   );
};

export default ChatProvider;

export const useChat = () => {
   const context = useContext(ChatContext);
   if (!context) throw new Error("You are trying to use Chat Context outside the Chat Provider");
   return context;
};
